import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";
import { rid } from "../../utils/shipinhao/utils";

export interface GetShipinhaoBgmParams extends ActiomCommonParams {
    query?: string; // 关键词查询
    currentPage?: number; // 当前页码
    pageSize?: number; // 每页数量
    type?: number; // 音乐类型（103: 推荐，其他值根据实际需求）
    lastBuffer?: string; // 分页标记
}

export interface BgmListResponse {
    errCode: number;
    errMsg: string;
    data: {
        items: BgmDetail[];
        lastBuffer: string;
        totalCount: number;
    };
}

export interface BgmDetail {
    listenItem: unknown;
}

export type GetBgmAction = CommonAction<GetShipinhaoBgmParams, BgmListResponse["data"]>;

export const getShipinhaoBgm: GetBgmAction = async (_task, params) => {
    // 验证 extraParam 是否存在
    if (!params.extraParam) {
        return response(400, "缺少 extraParam 参数", { items: [], lastBuffer: "", totalCount: 0 });
    }

    if (!params.extraParam.fingerPrintDeviceId || !params.extraParam.aId || !params.extraParam.uin) {
        return response(400, "fingerPrintDeviceId、aId和uin不能为空", { items: [], lastBuffer: "", totalCount: 0 });
    }

    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://channels.weixin.qq.com/micro/content/post/finderNewLifeCreate",
        origin: "https://channels.weixin.qq.com",
        "content-type": "application/json",
        "finger-print-device-id": params.extraParam.fingerPrintDeviceId,
        "x-wechat-uin": params.extraParam.uin,
    };

    const http = new Http({
        headers,
    });

    const urlParams = new URLSearchParams({
        _aid: params.extraParam.aId,
        _rid: rid(),
        _pageUrl: "https://channels.weixin.qq.com/micro/content/post/finderNewLifeCreate",
    }).toString();

    const requestData = {
        currentPage: params.currentPage ?? 1,
        lastBuffer: params.lastBuffer || "",
        pageSize: params.pageSize ?? 5,
        type: params.type ?? 103, // 有query时使用搜索模式104，否则使用推荐模式103
        recommendThumbUrlList: [],
        query: params.query || "", // 添加关键词查询参数
        timestamp: Date.now().toString(),
        _log_finder_uin: "",
        _log_finder_id: params.extraParam.finderUserName || "",
        rawKeyBuff: null,
        pluginSessionId: null,
        scene: 7,
        reqScene: 7,
    };

    const res = await http.api<BgmListResponse>({
        method: "post",
        url: `https://channels.weixin.qq.com/micro/content/cgi-bin/mmfinderassistant-bin/post/get_bgm_list?${urlParams}`,
        data: requestData,
    });

    const isSuccess = res?.errCode === 0;

    return response(isSuccess ? 0 : 414, res?.errMsg, res.data);
};
